import DesktopNavLinks from "../DesktopNav/DesktopNavLinks";
import MobileNavLinks from "../MobileNav/MobileNavLinks";

export default function UserMenu() {
  return (
    <>
      <DesktopNavLinks />
      <MobileNavLinks />
    </>
  );
}
